export const de_DE = {
    "PREFIX": {
        "QUESTION": "Frage",
        "QUESTION-PART": "Frage",
        "PRE-RELEASE": "Vorab",
        "JOURNAL": "Journal"
    },
    "CONTENT": {
        "MARK": "Punkte"
    }
};